import { render, staticRenderFns } from "./CatalogPage.vue?vue&type=template&id=50541051&lang=pug&"
import script from "./CatalogPage.vue?vue&type=script&lang=js&"
export * from "./CatalogPage.vue?vue&type=script&lang=js&"
import style0 from "./CatalogPage.vue?vue&type=style&index=0&lang=scss&scpoe=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports